module.exports = __webpack_public_path__ + "img/pro_capture3.42d15595.png";